import { useParams } from "react-router-dom";
import PageScaffold from "../../components/PageScaffold";
import { NUMBERS_PAGE_PATH } from "./NumbersPage";
import { useContext, useEffect } from "react";
import NumbersContext from "../../contexts/data/NumbersContext";
import { ContextStatus } from '@leedpulse-monorepo/enums';
import { Card } from "antd";
import NumberDetails from "../../components/numbers_page/NumberDetails";
import NumberCreationForm from "../../components/numbers_page/NumberCreationForm";
import { useNavigate } from "react-router-dom";

interface NumberDetailPageProps {
  isCreateMode: boolean;
}

const NumberDetailPage: React.FC<NumberDetailPageProps> = ({
  isCreateMode,
}) => {
  const navigate = useNavigate();
  const { numberId } = useParams<{ numberId: string }>();

  if (!numberId && !isCreateMode) {
    navigate(NUMBERS_PAGE_PATH);
    return null;
  }

  return <NumberDetailContent isCreateMode={isCreateMode} numberId={numberId} />;
};

interface NumberDetailContentProps {
  isCreateMode: boolean;
  numberId: string | undefined;
}

const NumberDetailContent: React.FC<NumberDetailContentProps> = ({
  isCreateMode,
  numberId,
}) => {
  const numbersContext = useContext(NumbersContext);

  const selectionMismatch =
    (!isCreateMode && numbersContext.selected === null) ||
    (!isCreateMode && numbersContext.selected?.sender !== numberId);

  useEffect(() => {
    if (
      selectionMismatch &&
      numbersContext.selectionStatus !== ContextStatus.LOADING && numberId
    ) {
      numbersContext.fetchAndSelectById(numberId);
    }
    return () => {
      numbersContext.reset();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <PageScaffold
      title={isCreateMode ? "Nouveau numéro" : 'Numéro ' + (numbersContext.selected?.sender || '')}
      subtitle={
        isCreateMode
          ? "Ajoutez un nouveau numéro"
          : "Consultez et modifiez les informations du numéro"
      }
      breadcrumbItems={[
        {
          target: NUMBERS_PAGE_PATH,
          title: "Numéros",
        },
        {
          title: isCreateMode ? "Nouveau" : numbersContext.selected?.sender || '',
        },
      ]}
    >
      {isCreateMode ? (
        <NumberCreationForm />
      ) : selectionMismatch || numbersContext.selected == null ? (
        <Card loading />
      ) : (
        <NumberDetails number={numbersContext.selected} />
      )}
    </PageScaffold>
  );
};

export default NumberDetailPage;
